export const formatDate = (date) => {
  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0") +
    "T" +
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0") +
    ":" +
    String(date.getSeconds()).padStart(2, "0") +
    "." +
    String(date.getMilliseconds()).padStart(3, "0")
  );
};

export const formatDateUTC = (date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    timeZone: "UTC",
  });

export const formatTimeUTC = (date) => {
  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format
  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
};

export const base64ToBlob = (base64, mimeType) => {
  const byteCharacters = atob(base64.split(",")[1]); // Decode Base64
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }

  return new Blob([new Uint8Array(byteArrays)], { type: mimeType });
};

export const generateEmailBody = (employeeName, lastPayDate) => `
    <html>
        <body style="font-family: Arial, sans-serif; color: #000;">
            <p>Dear ${employeeName}!</p>
            <p>Greetings from <strong>LGS STAFF MANAGEMENT SERVICES</strong>!</p>
            <p>This is to inform you that your final pay is now being processed, as all clearance procedures have been successfully completed.</p>
            <p>Your last pay, which includes your remaining salary and any unused leave credits (if applicable), will be processed and is scheduled for release through cheque on ${lastPayDate} from accounting from 9am to 4pm only.</p>
            <p><strong>Please make sure to bring a valid ID together with a printed, signed and notarized copy of your Quitclaim and Release Form</strong> on the day of claiming your final pay. This is a required document for the release.</p>
            <p>Thank you, and we wish you the very best in your future endeavors.</p>
            <p>Best Regards,</p>
            <p style="margin: 0;">LGS Staff Management Services Incorporated</p>
            <p style="margin: 0;">
              LGS Centre, <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian</a> corner Rockefeller St. Brgy. San Isidro, Makati City, 1234 Philippines
            </p>
            <p style="margin: 0;">Telephone No: (02) 8889-2680</p>
            <p style="margin: 0;">
              Facebook: <a href="https://www.facebook.com/LGSSTAFF" target="_blank">https://www.facebook.com/LGSSTAFF</a>
            </p>
            <p style="margin: 0;">
              Website: <a href="https://www.lgsstaff.com" target="_blank">www.lgsstaff.com</a>
            </p>
            <p style="margin-top:0;">"Our job is to make your job easier"</p>
      
            <i style="font-size:0.7rem">The content of this email is confidential and intended for the recipient specified in the message only. It is strictly forbidden to share any part of this message with any third party, without a written consent of the sender. If you received this message by mistake, please reply to this message and follow with its deletion, so that we can ensure such a mistake does not occur in the future.</i>
           <div style="display:flex">
              <img src="https://dev.lgs.mweeb.com/LGS_email_left.png" alt="LGS Logo Left" width="100" height="100" style="display:block;object-fit:contain;">
              <img src="https://dev.lgs.mweeb.com/LGS_email_right.jpg" alt="LGS Logo Right" width="100" height="100" style="display:block;object-fit:contain;">
            </div>
        </body>
    </html>
  `;
